import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';
import { VideoSection } from '@kinomap-dev/ng-ui-lib';

@Injectable({
  providedIn: 'root',
})
export class MapService {
  private readonly selectedVideoSubject$: BehaviorSubject<VideoSection | null> = new BehaviorSubject(null);

  readonly selectedVideo$: Observable<VideoSection | null> =
    this.selectedVideoSubject$.asObservable();
  readonly touchedIds: { [id: number]: boolean } = {};


  get selectedVideo(): VideoSection | null {
    return this.selectedVideoSubject$.getValue();
  }

  setSelectedVideo(video: VideoSection | null): void {
    this.selectedVideoSubject$.next(video);
    if (video) {
      this.touchedIds[video.id] = true;
    }
  }
}
